import { MDXRemote } from 'next-mdx-remote';

import { docsMdxComponents } from 'components/docs/docs-mdx-components';
import { DocsPagination } from 'components/docs/docs-pagination';
import type { DocsPage } from 'types/docs';

type DocsContentSectionProps = {
	doc: any;
	previous?: DocsPage;
	next?: DocsPage;
};

const DocsContentSection = ({ doc, previous, next }: DocsContentSectionProps) => (
	<article>
		<div className='prose-editorial'>
			<MDXRemote {...doc.content} components={docsMdxComponents} />
		</div>
		<DocsPagination previous={previous} next={next} />
	</article>
);

export { DocsContentSection };
